// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dc911c{align-items:center}.c4a963{margin-top:-0.75em;margin-bottom:-0.75em;width:2.25em;height:2.25em;-o-object-fit:cover;object-fit:cover;border-radius:4px;vertical-align:middle;margin-right:-0.25em}.c4a963~svg{margin-left:1em}", ""]);
// Exports
exports.locals = {
	"field": "dc911c",
	"image": "c4a963"
};
module.exports = exports;
